export type ApplicationErrorCode =
  | 'validation'
  | 'authentication'
  | 'network'
  | 'conflict'
  | 'partial-operation'
  | 'unknown';

export class ApplicationError extends Error {
  constructor(
    public readonly code: ApplicationErrorCode,
    message: string,
    public readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'ApplicationError';
  }
}

export const toApplicationError = (
  error: unknown,
  fallback: string,
): ApplicationError => {
  if (error instanceof ApplicationError) return error;
  return new ApplicationError('unknown', fallback, error);
};
